export default "__VITE_ASSET__CrzIIvzw__"